import Vuex from 'vuex'

import BaseStore from './baseStore'

const baseStore = new BaseStore()

const state = {
  ...baseStore.state
}
const getters = {
  ...baseStore.getters
}
const actions = {
  ...baseStore.actions
}
const mutations = {
  ...baseStore.mutations
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
